// these errors should not be reported to Sentry
export const NOT_REPORTED_ERRORS = ['NOT_FOUND', 'SAML', 'SERVICE_UNAVAILABLE', 'FORBIDDEN', 'AUTHENTICATION']
